/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {ApiKeyTableData, KTSVG} from '../../../../../_metronic/helpers'
import WSButton from '../../../../../_metronic/helpers/components/WSButton/WSButton'
import {WSSelect} from '../../../../../_metronic/helpers/components/WSSelect/WSSelect'

import CreateApiKeyModal from './CreateApiKeyModal'
import {useDispatch, useSelector} from 'react-redux'
import {
  DeleteApiKeysListOfuser,
  getApiKeysListOfuser,
  getApikeyListData,
  updateStatusOfApiKeys,
} from './ApikeysSlices/ApiKeysSlices'
import ConfirmationModel from '../../../../Components/ConfirmationModel'
import DeleteConfirmationPopup from '../../../../Components/DeleteConfirmationPopup'
import {toast} from 'react-toastify'
import {StatusColor} from '../../../../Utils/Constant/ArrayOfSideNav'
import moment from 'moment-timezone'
import {OverlayTrigger, Tooltip} from 'react-bootstrap'

const ApiKeyTable = ({visible, setVisible}: any) => {
  const dispatch = useDispatch()
  const [confirmationPopup, setConfirmationPopup] = useState(false)
  const [allow, setAllow] = useState(false)
  const [deleteId, setDeletedId] = useState('')
  const apikeyListData = useSelector(getApikeyListData)
  const [message, setMessage] = useState('')
  let options: any = [
    {value: 'Options', label: 'Options'},
    {value: 'Edit', label: 'Edit'},
    {value: 'Delete', label: 'Delete'},
  ]

  const logChange = (val: any) => {
    debugger
    setMessage(val)
  }
  useEffect(() => {
    if (allow) {
      dispatch(DeleteApiKeysListOfuser(deleteId))
      setAllow(false)
      setDeletedId('')
    }
  }, [allow])

  useEffect(() => {
    dispatch(getApiKeysListOfuser())
  }, [])

  return (
    <>
      <DeleteConfirmationPopup
        show={confirmationPopup}
        handleClose={() => setConfirmationPopup(false)}
        Message={'Are you sure, you want to delete this API key '}
        confirm={() => setAllow(true)}
      />
      <CreateApiKeyModal show={visible} handleClose={() => setVisible(false)} />
      <div className='card'>
        <div className='card-header'>
          <div className='card-title'>
            <h3 className='fs-2'>API Keys</h3>
          </div>
          <div className='card-toolbar align-items-center'>
            <a
              data-testid='btnNewAPIKey'
              href='#'
              className='btn btn-sm btn-primary text-white fw-500'
              onClick={() => setVisible(true)}
            >
              New API Key
            </a>
          </div>
        </div>
        <div className='card-body p-0'>
          <div className='table-responsive'>
            <table
              className='table table-flush align-middle table-row-bordered table-row-solid gy-4 gs-9'
              id='kt_api_keys_table'
            >
              <thead className='fs-5 text-gray-500'>
                <tr>
                  <th className='w-250px min-w-175px ps-9'>Label</th>
                  <th className='w-275px min-w-250px px-0'>API Keys</th>
                  <th className='w-125px min-w-125px'></th>
                  <th className='min-w-125px min-w-125px'>Created</th>
                  <th className='min-w-125px'>Status</th>
                  <th className='w-100px'></th>
                </tr>
              </thead>
              <tbody className='fs-6 fw-bold text-gray-600'>
                {apikeyListData?.map((data: any, i: any) => (
                  <tr key={i}>
                    <td className='ps-9'>{data?.name}</td>
                    <td data-bs-target='license' className='ps-0'>
                      <span className='d-inline-block text-truncate' style={{maxWidth: '250px'}}>
                        <OverlayTrigger
                          placement='top'
                          overlay={<Tooltip id='button-tooltip'>{data?.token}</Tooltip>}
                        >
                          <div className='text-truncate'>{data?.token}</div>
                        </OverlayTrigger>
                      </span>
                    </td>
                    <td>
                      <WSButton
                        onClick={() => {
                          console.log(navigator, 'navigator')

                          navigator.clipboard.writeText(data?.token)
                          toast.success('Copied!')
                        }}
                        data-action='copy'
                        className='btn btn-active-color-primary btn-icon btn-sm btn-outline-light'
                      >
                        <span className='svg-icon svg-icon-2'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <path
                              opacity='0.5'
                              d='M18 2H9C7.34315 2 6 3.34315 6 5H8C8 4.44772 8.44772 4 9 4H18C18.5523 4 19 4.44772 19 5V16C19 16.5523 18.5523 17 18 17V19C19.6569 19 21 17.6569 21 16V5C21 3.34315 19.6569 2 18 2Z'
                              fill='currentColor'
                            />
                            <path
                              fill-rule='evenodd'
                              clipRule='evenodd'
                              d='M14.7857 7.125H6.21429C5.62255 7.125 5.14286 7.6007 5.14286 8.1875V18.8125C5.14286 19.3993 5.62255 19.875 6.21429 19.875H14.7857C15.3774 19.875 15.8571 19.3993 15.8571 18.8125V8.1875C15.8571 7.6007 15.3774 7.125 14.7857 7.125ZM6.21429 5C4.43908 5 3 6.42709 3 8.1875V18.8125C3 20.5729 4.43909 22 6.21429 22H14.7857C16.5609 22 18 20.5729 18 18.8125V8.1875C18 6.42709 16.5609 5 14.7857 5H6.21429Z'
                              fill='currentColor'
                            />
                          </svg>
                        </span>
                      </WSButton>
                    </td>
                    <td>{moment(data?.createdAt)?.format('DD/MM/YYYY')}</td>
                    <td>
                      <span
                        className={`badge badge-light-${StatusColor?.[data?.status]} fs-7 fw-bold`}
                      >
                        {data?.status?.toUpperCase()}
                      </span>
                    </td>
                    <td className='pe-9'>
                      <div className='row align-items-center'>
                        <label className='col-6 switch me-4'>
                          <input
                            checked={data?.status === 'active'}
                            onChange={() =>
                              dispatch(
                                updateStatusOfApiKeys({
                                  id: data?._id,
                                  data: {
                                    status: data?.status === 'active' ? 'inactive' : 'active',
                                  },
                                })
                              )
                            }
                            className='form-check-input h-20px w-30px'
                            type='checkbox'
                            value=''
                            id='flexSwitchDefault'
                          />
                          <span className='slider round'></span>
                        </label>
                        <a
                          onClick={() => {
                            setConfirmationPopup(true)
                            setDeletedId(data?._id)
                          }}
                          className='col-6 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1 trash'
                        >
                          <span className='svg-icon svg-icon-3' data-testid='btnDelete'>
                            <KTSVG
                              path='/media/icons/duotune/art/trush.svg'
                              className='svg-icon-3'
                            />
                          </span>
                        </a>
                      </div>
                      {/* <div className='w-100px position-relative'>
                        <WSSelect
                          name='form-field-name'
                          className='border-0'
                          value={message}
                          onChange={logChange}
                          // defaultValue={options[0]?.label}
                          selectList={options}
                        />
                      </div> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default ApiKeyTable
